module.exports = __webpack_public_path__ + "img/Arco_Lines.43dc9b7d.png";